// Looker conditional formatting for single-value tiles (ticket #124).
//
// Looker keeps a tile's `conditional_formatting` rules in its vis config even
// after the author switches "Enable Conditional Formatting" OFF — the toggle is
// `enable_conditional_formatting`, and the rules simply sit there dormant (a
// fresh single_value tile even ships with a default rule). Pulse used to apply
// the rules whenever they existed, so tiles like "Running Entries Issued" lit up
// in colours the report author never turned on. Import means copy: the rules
// apply only when Looker's own toggle is on, and an absent toggle means off
// (Looker's default). Nulls are skipped unless `conditional_formatting_include_nulls`.
export function conditionalFormattingOn(visConfig) {
  return !!visConfig && visConfig.enable_conditional_formatting === true
    && Array.isArray(visConfig.conditional_formatting) && visConfig.conditional_formatting.length > 0;
}

// Evaluate the rules against the primary value. Rules apply in order; the last
// matching rule wins (matches Looker). Returns { background, font, bold } or null.
export function evalConditionalFormatting(visConfig, field, cell) {
  if (!conditionalFormattingOn(visConfig) || !cell) return null;
  const raw = cell.value;
  if (raw == null && visConfig.conditional_formatting_include_nulls !== true) return null;
  const v = Number(raw);
  let out = null;
  for (const r of visConfig.conditional_formatting) {
    if (!r || typeof r !== 'object') continue;
    if (Array.isArray(r.fields) && r.fields.length && field && !r.fields.includes(field.name)) continue;
    if (ruleMatches(r, v, raw)) {
      out = { background: r.background_color || undefined, font: r.font_color || undefined, bold: !!r.bold };
    }
  }
  return out;
}

function ruleMatches(r, v, raw) {
  switch (r.type) {
    case 'null': return raw == null;
    case 'not null': return raw != null;
    default: break;
  }
  if (raw == null || Number.isNaN(v)) return false;
  switch (r.type) {
    case 'greater than': return v > r.value;
    case 'greater than or equal to': return v >= r.value;
    case 'less than': return v < r.value;
    case 'less than or equal to': return v <= r.value;
    case 'equal to': return r.value != null && v === Number(r.value);
    case 'not equal to': return r.value != null && v !== Number(r.value);
    case 'between': return Array.isArray(r.value) && v >= r.value[0] && v <= r.value[1];
    case 'not between': return Array.isArray(r.value) && !(v >= r.value[0] && v <= r.value[1]);
    default: return false;
  }
}
